import React from "react";
import footerImg from "../../../images/footer-img.png";
import "./Footer.scss";

function Footer() {
  return (
    <div className="footer">
      <div className="container">
        <div className="footer__container">
          <p className="footer__text">а все это они придумали.. </p>
          <img src={footerImg} alt="footer" className="footer__img" />
        </div>
      </div>
    </div>
  );
}

export default Footer;
